import React, { useEffect, useMemo, useState } from "react";
import PropTypes from 'prop-types';
import '../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import TableContainer from '../../components/Common/TableContainer';

//import components
import Breadcrumbs from '../../components/Common/Breadcrumb';
//Import Flatepicker
import "flatpickr/dist/themes/material_blue.css";
import { mkConfig, generateCsv, download } from "export-to-csv";
import {
  getAllCustomers,
  getCities as onGetCities,
  getAllOrders,
  getPickUpPoints,
  getToysGrouped as onGetToys,
  setAllOrderStartDate,
  setAllOrdersEndDate
} from "store/actions";


//redux
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";

import {
  Col,
  Row,
  Card,
  CardBody,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
} from "reactstrap";
import Select from "react-select";
import Spinners from "components/Common/Spinner";
import { ToastContainer, toast } from "react-toastify";
import OffCanvasComponent from "pages/Customers/OffCanvasComponent";
import { filterOrders } from "./Upcoming";
import { get, post } from "helpers/api_helper";
import { formatDate, formatDateWithDay } from "helpers/date_helper";
import moment from "moment";
import RefundOrderModal from "components/Common/RefundOrderModal";
import EditOrderModal from "./EditOrder";
import AddOrderModal from "components/Common/addOrderModal";

function AllOrders() {

  //meta title
  document.title = "Master >> All Orders";
  const dispatch = useDispatch();
  const [week, setWeek] = useState(0);
  const [query, setQuery] = useState("");
  const [orders, setOrders] = useState([]);
  const [limit, setLimit] = useState(10);
  const [city, setCity] = useState("All");

  const [deliveryDate, setDeliveryDate] = useState("");
  const [duration, setDuration] = useState(2);
  const [availableDates, setAvailableDates] = useState({
    "w2": [],
    "w3": [],
    "w4": [],
  });

  const [pickupPoints, setPickupPoints] = useState([]);
  const [pickupPointSelected, setPickupPointSelected] = useState(false);
  const [pickupPoint, setPickupPoint] = useState({
    _id: "",
    storeName: "",
    city: "",
    status: false
  });

  const selectOrderState = (state) => state.Order;
  const OrderProperties = createSelector(
    selectOrderState,
    (Order) => ({
      allOrders: Order.allOrders,
      totalOrders: Order.totalOrders
    })
  );

  const selectDateState = (state) => state.OrderDates;
  const DateProperties = createSelector(
    selectDateState,
    (Dates) => ({
      _startDate: Dates.allOrdersStartDate,
      _endDate: Dates.allOrdersEndDate
    })
  );

  const selectPickUpPointState = (state) => state.PickupPoint;
  const PickupPointProperties = createSelector(
    selectPickUpPointState,
    (PickupPoint) => ({
      pickUpPoints: PickupPoint.pickUpPoints
    })
  );
  const { pickUpPoints } = useSelector(PickupPointProperties);

  const { allOrders, totalOrders } = useSelector(OrderProperties);

  const { _startDate, _endDate } = useSelector(DateProperties);

  const [startDate, setStartDate] = useState(_startDate);
  const [endDate, setEndDate] = useState(_endDate);

  const [isLoading, setLoading] = useState(true);


  const [pageNumber, setPage] = useState(1);
  useEffect(() => {
    dispatch(getAllOrders(pageNumber, limit, startDate, endDate, query, city));
    dispatch(getPickUpPoints());
  }, [dispatch, pageNumber, startDate, endDate, limit, query, city]);

  const [pickUpType, setPickUpType] = useState("All");
  const [pickUpPoint, setpickUpPoint] = useState("All");

  useEffect(() => {
    setOrders(filterOrders(allOrders, pickUpPoint, pickUpType));
  }, [pickUpType, pickUpPoint, startDate, endDate])

  const [isCanvasOpen, setIsCanvasOpen] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState({});
  const [editOrder, setEditOrder] = useState(false);
  const [selectedToy, setSelectedToy] = useState({});
  const [selectedToyUnit, setSelectedToyUnit] = useState(null);
  const [toyError, setToyError] = useState("");

  const handleToyChange = (toy) => {
    setSelectedToy(toy);
    setSelectedToyUnit(null);
  };

  const toggleCanvas = () => {
    setIsCanvasOpen(!isCanvasOpen);
  };

  const editOrderCanvasToggle = () => {
    setEditOrder(!editOrder);
    setSelectedOrder({});
    setSelectedToy({});
    setSelectedToyUnit(null);
    setAvailableDates({
      "w2": [],
      "w3": [],
      "w4": [],
    });
  }
  const [availabilityLoading, setAvailabilityLoading] = useState(false);
  const getAvailibility = async (deliveryDate, duration, orderId, toyId, pickupPointSelected, toyUnitId) => {
    setAvailabilityLoading(true);
    setToyError("")
    try {
      let _deliveryDate = deliveryDate ? new Date(deliveryDate).toISOString() : selectedOrder?.deliveryDate;
      const res = await post(`orders/check-toy-availability/${toyId}`, { orderId, deliveryDate: _deliveryDate, duration, selfPickup: pickupPointSelected, toyUnitId });
      console.log(res);
      setAvailableDates(res?.availability);
      setDeliveryDate(moment(deliveryDate).format("YYYY-MM-DD"));
    } catch (error) {
      setAvailableDates(error?.response?.data?.availability);
      console.log("Error in getting availibility", error);
      setDeliveryDate("");
      let message = error?.response?.data?.message || "Error in getting availibility";
      setToyError(message);
    }
    setAvailabilityLoading(false);
  }

  useEffect(() => {
    if (selectedToy?._id) {
      getAvailibility(deliveryDate, duration, selectedOrder?._id, selectedToy?._id, pickupPointSelected, selectedToyUnit?.value);
    }
  }, [selectedToy, selectedOrder, pickupPointSelected, selectedToyUnit]);

  const fetchPickUpPoints = async () => {
    try {
      const res = await get(`orders/pickup-points/${selectedOrder?.customer?._id}`);
      setPickupPoints(res?.pickUpPoints);
    } catch (error) {
      console.log("Error in fetching pick up points", error);
    }
  }

  useEffect(() => {
    if (selectedOrder?.customer?._id !== undefined) {
      fetchPickUpPoints();
    }
  }, [selectedOrder?.customer?._id]);

  const saveOrder = async () => {
    try {
      if (!selectedToyUnit?.value) {
        toast.error("Please select a toy unit");
        return;
      }
      if (!deliveryDate) {
        toast.error("Please select a delivery date");
        return;
      }
      if (moment(selectedOrder.deliveryDate).format('YYYY-MM-DD') !== moment(deliveryDate).format('YYYY-MM-DD')) {
        if (availableDates && availableDates["w" + duration]?.includes(deliveryDate) === false) {
          toast.error(`Toy is not available for selected duration on ${formatDateWithDay(deliveryDate)}`);
          return;
        }
      }
      if (pickupPointSelected && !pickupPoint?._id) {
        toast.error("Please select a pickup point");
        return;
      }
      const res = await post(`/orders/edit-order/${selectedOrder?._id}`, { toyId: selectedToyUnit.value, deliveryDate, duration, pickupPoint: pickupPointSelected ? pickupPoint : null });
      setEditOrder(false);
      setSelectedOrder({});
      setSelectedToy({});
      setSelectedToyUnit(null);
      toast.success("Order updated successfully");
      dispatch(getAllOrders(pageNumber, limit, startDate, endDate, query, city));
    }
    catch (error) {
      setEditOrder(false);
      setSelectedOrder({});
      setSelectedToy({});
      setSelectedToyUnit(null);
      console.log("Error in editing order", error);
      let message = error?.response?.data?.message || "Error in editing order";
      toast.error(message);
    }
  }

  const selectToyState = (state) => state.Toy;
  const ToyProperties = createSelector(
    selectToyState,
    (Toy) => ({
      toys: Toy.toys,
    })
  );

  const { toys } = useSelector(ToyProperties);
  useEffect(() => {
    dispatch(onGetToys(1, 1000, "", "all", "all", "all", "all", "all"));
  }, [dispatch]);

  console.log(toys)

  const onOrderClick = (orderDetails) => {
    toggleCanvas();
    setSelectedOrder(orderDetails);
  }
  //Open a Modal to edit the order
  const onOrderEditClick = (orderDetails) => {
    console.log("Edit Order:: ", orderDetails);
    setEditOrder(true);
    setSelectedOrder(orderDetails);
    const groupedToy = toys.find(t => t.variants?.some(v => v._id === orderDetails?.toy?._id)) || toys.find(t => t._id === orderDetails?.toy?._id) || orderDetails?.toy;
    setSelectedToy(groupedToy);
    const matchedUnit = groupedToy?.variants?.find(v => v._id === orderDetails?.toy?._id) || orderDetails?.toy;
    setSelectedToyUnit(matchedUnit ? { value: matchedUnit._id, label: matchedUnit.code, unit: matchedUnit } : null);
    setDuration(parseInt(orderDetails?.duration));
    setDeliveryDate(orderDetails?.deliveryDate);
    setPickupPoint(orderDetails?.selfPickup);
    setPickupPointSelected(orderDetails?.selfPickup ? true : false);
    getAvailibility(orderDetails?.deliveryDate, orderDetails?.duration, orderDetails?._id, groupedToy?._id || orderDetails?.toy?._id, orderDetails?.selfPickup ? true : false, orderDetails?.toy?._id);
  }

  const csvConfig = mkConfig({ useKeysAsHeaders: true });

  const exportToCSVButtonClicked = async () => {
    try {
      const res = await post(`/orders/all/${pageNumber}/${limit}?query=${query}&city=${city}`, { startDate, endDate, csvTrue: true });

      if (res.success === false) {
        toast.error("Error in exporting data");
        return;
      }
      const csvData = res?.orders?.map((order) => {
        return {
          orderId: order?.orderId,
          customerName: order?.customer?.fname + " " + order?.customer?.lname,
          mobile: order?.customer?.mobile,
          toy_pic: order?.toy?.defaultPhoto,
          toy_name: order?.toy?.name,
          toy_code: order?.toy?.code,
          city: order?.customer?.city?.name,
          zone: order?.customer?.zone?.name ? order?.customer?.zone?.name : "Not Available",
          pincode: order?.customer?.pincode,
          orderDate: formatDate(order?.createdAt),
          deliveryDate: formatDate(order?.deliveryDate),
          returnDate: formatDate(order?.returnDate),
          orderTotal: order?.orderTotal,
          duration: (order?.duration * 7) + " days",
          paid: order?.paid,
          selfPickup: order?.selfPickup ? "Yes" : "No",
        };
      });

      if (csvData.length === 0) {
        toast.error("No data to export");
        return;
      }

      const csv = generateCsv(csvConfig)(csvData);
      download(csvConfig)(csv)

    } catch (error) {
      toast.error("Error in exporting data");
      console.log("Error in exporting data", error);
    }
  }

  const selectCityState = (state) => state.City;
  const CityProperties = createSelector(
    selectCityState,
    (City) => ({
      cities: City.cities
    })
  );

  const { cities } = useSelector(CityProperties);

  useEffect(() => {
    dispatch(onGetCities());
  }, [dispatch]);

  const columns = useMemo(
    () => [
      {
        Header: 'Order ID',
        accessor: "orderId",
        width: "150px",
        style: {
          textAlign: "center",
          width: "10%",
          background: "#0000",
        },
        filterable: true,
        Cell: ({ row }) => {
          return <>{row?.original?.orderId ?? " "} </>;
        },
      },
      {
        Header: 'Customer Name',
        accessor: 'name',
        width: '150px',
        style: {
          textAlign: "center",
          width: "10%",
          background: "#0000",
        },
        filterable: true,
        Cell: (cellProps) => {
          return <>
            {cellProps?.row?.original?.customer?.fname?.charAt(0).toUpperCase() + cellProps?.row?.original?.customer?.fname?.slice(1) + " " + cellProps?.row?.original?.customer?.lname?.charAt(0).toUpperCase() + cellProps?.row?.original?.customer?.lname?.slice(1)}
          </>;
        }
      },
      {
        Header: 'City',
        accessor: 'city',
        width: '150px',
        style: {
          textAlign: "center",
          width: "10%",
          background: "#0000",
        },
        filterable: true,
        Cell: (cellProps) => {
          return <>
            {cellProps?.row?.original?.customer?.city?.name}
          </>;
        }
      },
      {
        Header: 'Zone',
        accessor: 'zone',
        width: '150px',
        style: {
          textAlign: "center",
          width: "10%",
          background: "#0000",
        },
        filterable: true,
        Cell: (cellProps) => {
          return <>
            {cellProps?.row?.original?.customer?.zone?.name ? cellProps?.row?.original?.customer?.zone?.name : "Not Available"}
          </>;
        }
      },
      {
        Header: 'Amount',
        accessor: 'amount',
        width: '150px',
        style: {
          textAlign: "center",
          width: "10%",
          background: "#0000",
        },
        filterable: true,
        Cell: (cellProps) => {
          return <>
            ₹ {cellProps?.row?.original?.orderTotal}
          </>;
        }
      },
      {
        Header: 'Delivery Date',
        accessor: 'deliveryDate',
        width: '150px',
        style: {
          textAlign: "center",
          width: "10%",
          background: "#0000",
        },
        filterable: true,
        Cell: (cellProps) => {
          return <>
            {formatDate(cellProps?.row?.original?.deliveryDate)}
          </>;
        }
      },
      {
        Header: 'Return Date',
        accessor: 'returnDate',
        width: '150px',
        style: {
          textAlign: "center",
          width: "10%",
          background: "#0000",
        },
        filterable: true,
        Cell: (cellProps) => {
          return <>
            {formatDate(cellProps?.row?.original?.returnDate)}
          </>;
        }
      },
      {
        Header: 'Toy Name',
        accessor: 'toy_name',
        width: '150px',
        style: {
          textAlign: "center",
          width: "10%",
          background: "#0000",
        },
        filterable: true,
        Cell: (cellProps) => {
          return <>
            {cellProps?.row?.original?.toy?.name}
          </>;
        }
      },
      {
        Header: 'Toy Code',
        accessor: 'toy_code',
        width: '150px',
        style: {
          textAlign: "center",
          width: "10%",
          background: "#0000",
        },
        filterable: true,
        Cell: (cellProps) => {
          return <>
            {cellProps?.row?.original?.toy?.code || "N/A"}
          </>;
        }
      },
      {
        Header: 'Duration',
        accessor: 'duration',
        width: '150px',
        style: {
          textAlign: "center",
          width: "10%",
          background: "#0000",
        },
        filterable: true,
        Cell: (cellProps) => {
          return <>
            {/* display duration in days */}
            {(cellProps?.row?.original?.duration * 7) + " days"}
          </>;
        }
      },
      {
        Header: "Action",
        accessor: "action",
        width: "150px",
        style: {
          textAlign: "center",
          width: "10%",
          background: "#0000",
        },
        filterable: true,
        Cell: ({ row }) => {

          return (
            <div className="d-flex gap-1">
              <Button
                color="primary"
                onClick={() => onOrderClick(row?.original)}
              >
                View
              </Button>
              <Button
                color="warning"
                onClick={() => onOrderEditClick(row?.original)}
              >
                Edit
              </Button>
            </div>
          );
        }
      }
    ],
    []
  );

  const [addOrderModal, setAddOrderModal] = useState(false);

  return (
    <React.Fragment>

      <AddOrderModal
        show={addOrderModal}
        onCloseClick={() => setAddOrderModal(false)}
        getAllOrders={() => dispatch(getAllOrders(pageNumber, limit, startDate, endDate, query, city))}
      />
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Home" breadcrumbItem="All Orders" />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>

                  <TableContainer
                    title="Age Group"
                    columns={columns}
                    data={week == 0 && pickUpType === "All" ? allOrders : orders}
                    addOrder={true}
                    handleAddOrderClick={() => setAddOrderModal(true)}
                    // isGlobalFilter={true}
                    // isAddOptions={true}
                    isCustomGlobalFilter={true}
                    setQuery={setQuery}
                    isStartDate={true}
                    startDate={startDate}
                    setStartDate={(date) => {
                      setStartDate(date);
                      dispatch(setAllOrderStartDate(date));
                    }}
                    isEndDate={true}
                    endDate={endDate}
                    setEndDate={(date) => {
                      setEndDate(date);
                      dispatch(setAllOrdersEndDate(date));
                    }}
                    DateFilterTitle={"Delivery Date"}
                    handleOrderClicks={() => { }}
                    customPageSize={10}
                    isPagination={false}
                    filterable={false}
                    csvExport={true}
                    exportToCSVButtonClicked={exportToCSVButtonClicked}
                    // isPickUpPointOptions={true}
                    isCityFilter={true}
                    cities={cities}
                    setCity={setCity}
                    city={city}
                    pickUpType={pickUpType}
                    setPickUpType={setPickUpType}
                    pickUpPoints={pickUpPoints}
                    setpickUpPoint={setpickUpPoint}
                    pickUpPoint={pickUpPoint}
                    iscustomPageSizeOptions={true}
                    tableClass="align-middle table-check"
                    theadClass="table-light"
                    pagination="pagination pagination-rounded justify-content-end mb-2"
                    isCustomPagination={true}
                    setPage={setPage}
                    pageNumber={pageNumber}
                    totals={totalOrders}
                    setLimit={setLimit}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
      <ToastContainer />
      <EditOrderModal
        show={editOrder}
        onCloseClick={editOrderCanvasToggle}
        selectedOrder={selectedOrder}
        toys={toys}
        duration={duration}
        setDuration={setDuration}
        pickupPointSelected={pickupPointSelected}
        toyError={toyError}
        saveOrder={saveOrder}
        availabilityLoading={availabilityLoading}
        selectedToy={selectedToy}
        setPickupPointSelected={setPickupPointSelected}
        setPickupPoint={setPickupPoint}
        availableDates={availableDates}
        setToyError={setToyError}
        setAvailabilityLoading={setAvailabilityLoading}
        pickupPoints={pickupPoints}
        pickupPoint={pickupPoint}
        setDeliveryDate={setDeliveryDate}
        deliveryDate={deliveryDate}
        setSelectedToy={setSelectedToy}
        selectedToyUnit={selectedToyUnit}
        setSelectedToyUnit={setSelectedToyUnit}
        handleToyChange={handleToyChange}
      />
      <OffCanvasComponent
        isCanvasOpen={isCanvasOpen}
        toggleCanvas={toggleCanvas}
        selectedOrder={selectedOrder}
      />
    </React.Fragment>
  );
}
AllOrders.propTypes = {
  preGlobalFilteredRows: PropTypes.any,

};


export default AllOrders;